(function () {

    function Collapsibles() {

        /**
         * Selector for the wrapper of a collapse
         *
         * @type {string}
         * @private
         */
        const WRAPPER_SELECTOR = ".collapse__wrapper";

        /**
         * Selector for the toggle of a collapse
         *
         * @type {string}
         * @private
         */
        const TOGGLE_SELECTOR = "[data-toggle='collapsible']";

        /**
         * Selector for the collapsible of a collapse
         * This is the part that actually is collapsing/expanding
         *
         * @type {string}
         * @private
         */
        const COLLAPSIBLE_SELECTOR = ".collapse__collapsible";

        /**
         * Selector for the reverted button text (needed for collapsible button)
         *
         * @type {string}
         * @private
         */
        const COLLAPSIBLE_BUTTON_TYPE_SELECTOR = "data-collapsible-button-revert-text";

        /**
         * local object availability
         * @type {Collapsibles}
         * @private
         */
        var _this = this;

        /**
         * Scrolls, if enabled in the backend, to the expanding collapsible
         * The data parameter "scroll-to" is inherited from the parent accordion
         *
         * @method scrollToExpanding
         * @returns {undefined}
         */
        this.scrollToExpanding = function (expanding) {
            if (expanding.parentElement.dataset.scrollTo === 'true') {
                const headerOffset = document.querySelector('header').offsetHeight; // header offset
                const collapsingHeightAbove = _this.collapsingHeightAbove(expanding); // takes care of the offset of collapsibles above the current if they will be collapsed
                const offset = headerOffset + collapsingHeightAbove;
                const collapsiblePos = expanding.parentElement.getBoundingClientRect().top + window.pageYOffset; // collapsibles y position relative to document

                const scrollPos = collapsiblePos - offset; // resulting scroll position so that the collapsible is exactly under the header

                window.scrollTo({
                    top: scrollPos,
                    left: 0,
                    behavior: 'smooth'
                });
            }
        };

        /**
         * Calculates the height of collapsing collapsbiles above the currently expanding
         * Used to determine the the correct offset for the scroll position
         *
         * @method collapsingHeightAbove
         * @param {HTMLElement} expanding
         * @returns {number} collapsingHeightAbove      Height of the collapsing elements above the expanding
         */
        this.collapsingHeightAbove = function (expanding) {
            var collapsingHeightAbove = 0;
            if (expanding.parentElement.parentElement.classList.contains('accordion')) {

                const accordion = expanding.parentElement.parentElement;
                const collapsibles = accordion.querySelectorAll(COLLAPSIBLE_SELECTOR);

                for (var i = 0; i < collapsibles.length; i++) {

                    const isExpanded = collapsibles[i].dataset.expanded === 'true';
                    const isClosableByOthers = collapsibles[i].parentElement.dataset.closeOthers === 'true';
                    const isAboveCurrent = collapsibles[i].getBoundingClientRect().top < expanding.getBoundingClientRect().top;

                    if (isExpanded && isClosableByOthers && isAboveCurrent) {
                        collapsingHeightAbove += collapsibles[i].offsetHeight;
                    }
                }
            }
            return collapsingHeightAbove;
        };

        /**
         * Collapses, if enabled in the backend, all other collapsibles in the current accordion container
         * The data parameter "close-others" is inherited from the parent accordion
         *
         * @method collapseOthers
         * @param {HTMLElement} expanding
         * @returns {undefined}
         */
        this.collapseOthers = function (expanding) {
            if (!expanding.parentElement.parentElement.classList.contains('accordion')) {
                return;
            }

            const accordion = expanding.parentElement.parentElement;
            const collapsibles = accordion.querySelectorAll(COLLAPSIBLE_SELECTOR);

            for (var i = 0; i < collapsibles.length; i++) {

                const isExpanded = collapsibles[i].dataset.expanded === 'true';
                const isClosableByOthers = collapsibles[i].parentElement.dataset.closeOthers === 'true';

                if (isExpanded && isClosableByOthers) {
                    this.collapse(collapsibles[i]);
                }
            }
        };

        /**
         * Expands the given "expanding" DOM element
         *
         * @method expand
         * @param {HTMLElement} expanding
         * @returns {undefined}
         */
        this.expand = function (expanding) {
            // get the height of the collapsible's inner content, regardless of its actual size
            const expandingHeight = expanding.scrollHeight;
            const transitionDuration = parseFloat(getComputedStyle(expanding).transitionDuration.replace('s', '')) * 1000;

            // have the collapsible transition to the height of its inner content
            expanding.style.height = expandingHeight + 'px';

            // when the next css transition finishes (which should be the one we just triggered)
            setTimeout(function (e) {
                // remove "height" from the collapsible's inline styles, so it can return to its initial value
                expanding.style.height = null;
            }, transitionDuration);

            // mark the section as "currently not collapsed"
            expanding.dataset.expanded = "true";
            expanding.parentElement.classList.remove('collapsed');
        };

        /**
         * Collapses the given "collapsible" DOM element
         *
         * @method collapse
         * @param {HTMLElement} collapsing
         * @returns {undefined}
         */
        this.collapse = function (collapsing) {
            collapsing.classList.add('collapsing');

            // get the height of the collapsible's inner content, regardless of its actual size
            const collapsibleHeight = collapsing.scrollHeight;

            // temporarily disable all css transitions
            const collapsibleTransition = collapsing.style.transition;
            collapsing.style.transition = '';

            // on the next frame (as soon as the previous style change has taken effect),
            // explicitly set the collapsible's height to its current pixel height, so we
            // aren't transitioning out of 'auto'
            requestAnimationFrame(function () {
                collapsing.style.height = collapsibleHeight + 'px';
                collapsing.style.transition = collapsibleTransition;

                // on the next frame (as soon as the previous style change has taken effect),
                // have the collapsible transition to height: 0
                requestAnimationFrame(function () {
                    collapsing.style.height = 0 + 'px';
                    collapsing.classList.remove('collapsing');
                });
            });
            // mark the collapsible as "currently collapsed"
            collapsing.dataset.expanded = 'false';
            collapsing.parentElement.classList.add('collapsed');
        };

        /**
         * Toggles the given "collapsible" DOM element.
         * If a collapsible is opened, the browser scrolls to the desired expanding and closes all other collapsibles
         *
         * @method toggle
         * @param {HTMLElement} collapsible
         * @returns {undefined}
         */
        this.toggle = function (collapsible) {
            if (collapsible.dataset.expanded === 'true') {
                _this.collapse(collapsible);
            } else {
                _this.scrollToExpanding(collapsible);
                _this.collapseOthers(collapsible);
                _this.expand(collapsible);
            }
        };

        /**
         * Initializes a given collapsibleWrapper
         *
         * @method initCollapsible
         * @param {HTMLElement} collapsibleWrapper
         * @returns {undefined}
         */
        this.initCollapsible = function (collapsibleWrapper) {
            var collapsible = collapsibleWrapper.querySelector(COLLAPSIBLE_SELECTOR);
            var toggle = collapsibleWrapper.querySelector(TOGGLE_SELECTOR);

            // expand all collapsibles in the backend
            if (!document.querySelector('body').classList.contains('neos-backend')) {
                // if the parsed collapsible initially is expanded
                if (collapsible.dataset.expanded === 'true') {
                    _this.expand(collapsible);
                }
                toggle.addEventListener('click', function () {
                    var clickedCollapsible = this.parentElement.querySelector(COLLAPSIBLE_SELECTOR);
                    _this.toggle(clickedCollapsible);

                    // Special behavior for the NodeType: TechDivision.NodeTypes:Content.CollapsibleButton
                    if (_this.isCollapsibleButtonType()) {
                        console.log(_this.isCollapsibleButtonType());


                        _this.collapsibleButtonBehavior(this.parentElement);
                    }
                }, false);
            } else {
                _this.expand(collapsible);
            }
        };

        /**
         * Checks if it is a collapsible button type
         *
         * @method isCollapsibleButtonType
         * @returns {Element}
         */
        this.isCollapsibleButtonType = function () {
            return document.querySelector('[data-collapsible="wrapper"]');
        };

        /**
         * Controls the behavior of the Text button.
         * Changes text depending on open/closed state
         *
         * @method collapsibleButtonBehavior
         * @param {HTMLElement} parentElementDom
         * @returns {undefined}
         */
        this.collapsibleButtonBehavior = function (parentElementDom) {
            var currentButtonText = parentElementDom.querySelector('[' + COLLAPSIBLE_BUTTON_TYPE_SELECTOR + ']').innerHTML;

            parentElementDom.querySelector('[' + COLLAPSIBLE_BUTTON_TYPE_SELECTOR + ']').innerHTML = parentElementDom.querySelector('[' + COLLAPSIBLE_BUTTON_TYPE_SELECTOR + ']').getAttribute(COLLAPSIBLE_BUTTON_TYPE_SELECTOR);
            parentElementDom.querySelector('[' + COLLAPSIBLE_BUTTON_TYPE_SELECTOR + ']').setAttribute(COLLAPSIBLE_BUTTON_TYPE_SELECTOR, currentButtonText);
        };

        /**
         * Initializes all collapsibles
         *
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            var collapseWrappers = document.querySelectorAll(WRAPPER_SELECTOR);
            for (var i = 0; i < collapseWrappers.length; i++) {
                _this.initCollapsible(collapseWrappers[i]);
            }
        };

        /**
         * initial collapsibles call
         */
        _this.init();
    }

    /**
     * global availability
     */
    window.TechDivision = window.TechDivision || {};
    window.TechDivision.Collapsibles = Collapsibles;
})();

if (document.readyState != 'loading') {
    new window.TechDivision.Collapsibles();
} else {
    document.addEventListener('DOMContentLoaded', new window.TechDivision.Collapsibles());
}
